import Button from '~/components/Buttons/Button'

export default function ProductCardButton({
  className = '',
  href,
  label,
  onClick,
}: {
  className?: string
  href?: string
  label: string
  onClick?: () => void
}): React.ReactElement {
  return (
    <Button
      className={`bg-orange ring ring-black text-black text-2xl lg:!text-3xl rounded-2.5 px-16 hover:bg-purple-dark hover:ring-purple-dark hover:text-white focus:ring-8 lg:focus:ring-purple-light transition-colors duration-300 ease-in-out ${className}`}
      href={href}
      isWide
      onClick={onClick}
      size="medium"
    >
      {label}
    </Button>
  )
}
